import React from 'react';

import { ReactComponent as CompassRoseIcon} from './compass.svg';
import './MapCompassRose.scss';

const MapCompassRose = () => (
  <div className="mapCompassRose">
    <CompassRoseIcon/>
  </div>
);

export default MapCompassRose;
